module.exports = __webpack_public_path__ + "static/media/speech_sound.bf3dceba.mp3";